import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Collapse } from 'antd';
import AccordionTitle from './AccordionTitle';
import {
  Accordion,
  AccordionSub,
  SalonCover,
  SalonCoverTitle,
  SalonCoverItem,
  SalonCoverLink,
  Link,
} from './Accordion.style';

// eslint-disable-next-line prefer-destructuring
const Panel = Collapse.Panel;
const linkIds = {
  regions0: 0,
  regions1: 1,
  regions2: 2,
  regions3: 3,
  regions4: 4,
  regions5: 5,
  regions6: 6,
  regions7: 7,
};
export default class SalonList extends Component {
  static defaultProps = {
    regions: [],
    categoryKey: undefined,
    product: undefined,
  };
  static propTypes = {
    regions: PropTypes.arrayOf(PropTypes.shape()),
    searchByPrefecture: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentKey: undefined,
      currentKeySub: undefined,
      render: undefined, // eslint-disable-line
    };
  }

  accordionHandle = async key => {
    if (key) {
      this.setState({ currentKey: key });
    } else {
      this.setState({ currentKey: undefined });
    }
  };

  prefFilter = id => {
    return new Promise((resove,reject) => {
      this.props.regions && this.props.regions.map(item => {
        if(item.id === id) resove(item.region);
        item.prefectures.map(pre => {
          if(pre.id === id) resove(pre.prefecture);
        })
      })
    })
  }

  accordionSubHandle = async key => {
    if (key) {
      const {categoryKey, product} = this.props;
      this.setState({ currentKeySub: key });
      const pref = await this.prefFilter(key);
      const lineFilter = [{ lineFieldId: 'lines_'+ categoryKey, lines: [product.product.key] }];
      const lineFilterString = encodeURIComponent(JSON.stringify(lineFilter));
      this.changeIsLoading(pref);
      this.props.searchByPrefecture(lineFilterString, pref);
    } else {
      this.setState({ currentKeySub: undefined });
    }
  };

  changeIsLoading = pref => {
    this.props.regions.map(region => {
      region.prefectures.map(prefecture => {
        if (prefecture.prefecture === pref) {
          prefecture["isLoading"] = true;
          this.setState({
            render: new Date() // eslint-disable-line
          });
        }
      });
    });
  };

  render() {
    const { currentKey, currentKeySub } = this.state;
    const { regions, linkId } = this.props;
    return (
      <React.Fragment>
        <Accordion accordion onChange={this.accordionHandle} defaultActiveKey={[`"${linkIds[linkId]}"`]}>
          {regions.map((item, index) => (
            <Panel
              id={`regions${index}`}
              header={
                <AccordionTitle
                  type="parent"
                  isShow={(currentKey && Number(currentKey) === Number(item.id)) || false}
                  title={item.region}
                />
              }
              key={item.id}
              showArrow={false}
            >
              <AccordionSub accordion onChange={this.accordionSubHandle} defaultActiveKey={['1111']}>
                {item.prefectures.map(sub => (
                  <Panel
                    header={
                      <AccordionTitle
                        type="child"
                        isShowChild={(currentKeySub && Number(currentKeySub) === Number(sub.id)) || false}
                        noBorder
                        title={sub.prefecture}
                        isLoading={sub.isLoading}
                      />
                    }
                    key={sub.id}
                    showArrow={false}
                  >
                    {sub.salons === undefined && 'Loading ... '}
                    {sub.salons !== undefined && sub.salons.length === 0 && 'no data'}
                    {sub.salons &&
                      sub.salons.map((salon, no) => (
                        <SalonCover key={salon.salonRandomId}>
                          <SalonCoverTitle>
                            {no + 1}. {salon.name}
                          </SalonCoverTitle>
                          <SalonCoverItem>
                            <SalonCoverLink
                              href={
                                salon.country === '日本'
                                  ? `https://maps.google.co.jp/maps?q=${salon.address2} ${salon.address1} ${salon.name}`
                                  : `https://maps.google.co.jp/maps?q=${salon.address1} ${salon.address2} ${salon.name}`
                              }
                              target="_blank"
                            >
                              {salon.country === '日本'
                                ? `〒${salon.zipCode} ${salon.address2} ${salon.address1}`
                                : `${salon.address1} ${salon.address2} ${salon.zipCode}`}
                            </SalonCoverLink>
                          </SalonCoverItem>
                          <SalonCoverItem>
                            tel: <Link href={`tel:${salon.phoneNumber}`}>{salon.phoneNumber}</Link>
                          </SalonCoverItem>
                        </SalonCover>
                      ))}
                  </Panel>
                ))}
              </AccordionSub>
            </Panel>
          ))}
        </Accordion>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SalonList/Accordion.js